function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  className: styles["button-glyph"] || "button-glyph",
  xmlns: "http://www.w3.org/2000/svg",
  width: "22.5",
  height: "14.6"
}, props), /*#__PURE__*/React.createElement("title", null, "@AccessibilityStrings.ToggleMenu"), /*#__PURE__*/React.createElement("path", {
  d: "M21.4 2.1H1a1 1 0 010-2h20.4c.6 0 1 .5 1 1 .1.5-.4 1-1 1zm0 4.5H1a1 1 0 000 2h20.4c.6 0 1-.5 1-1 .1-.5-.4-1-1-1zm0 5.9H1a1 1 0 000 2h20.4c.6 0 1-.5 1-1 .1-.5-.4-1-1-1z"
}));